import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { Alignment, FlexBox, Orientation, SkeletonRectangle, SkeletonRectangleVariant } from '@lumapps/lumx/react';

import './index.scss';

export interface ExpandableTreeSkeletonsProps {
    className?: string;
}

export const ExpandableTreeSkeletons: React.FC<ExpandableTreeSkeletonsProps> = ({ className }) => {
    const { block } = useClassnames('expandable-tree');

    return (
        <FlexBox gap="regular" orientation={Orientation.vertical} fillSpace hAlign={Alignment.top}>
            <SkeletonRectangle
                variant={SkeletonRectangleVariant.rounded}
                className={block('list-skeleton', [className])}
            />
            <SkeletonRectangle
                variant={SkeletonRectangleVariant.rounded}
                className={block('list-skeleton', [className])}
            />
            <SkeletonRectangle
                variant={SkeletonRectangleVariant.rounded}
                className={block('list-skeleton', [className])}
            />
        </FlexBox>
    );
};
